export default "__VITE_ASSET__CJHL5Qel__"